import {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import "./index.css";
import App from "./App";
import {I18nextProvider} from "react-i18next";
import i18next from "i18next";
import global_en from "./locales/en/globals.json";
import global_it from "./locales/it/globals.json";
import global_fr from "./locales/fr/globals.json";

i18next.init({
    interpolation: {escapeValue: false},
    lng: "fr",
    fallbackLng: "fr",
    resources: {
        en: {
            global: global_en,
        },
        it: {
            global: global_it,
        },
        fr: {
            global: global_fr,
        },
    },
});

createRoot(document.getElementById("root")).render(
    <StrictMode>
        <I18nextProvider i18n={i18next}>
            <App />
        </I18nextProvider>
    </StrictMode>
);
